import type { NotifyInterestDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementsService {
  apiName = 'Default';

  notifyInterest = (input: NotifyInterestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/culture/announcements/interest',
      body: input,
    },
    { apiName: this.apiName, ...config });

  constructor(private restService: RestService) {}
}
